import Month from './Month'
import { today, currentMonth } from './now'

export default {
	name: 'Calendar',
	props: {
		today: {
			type: Date,
			default: today
		},
		month: {
			type: Date,
			default: currentMonth
		},
		min: {
			type: Date
		},
		max: {
			type: Date
		},
		attrs: {
			type: Array,
			default: []
		}
	},
	data () {
		return {
			aMonth: this.month
		}
	},
	components: {
		Month
	},
	template: `
		<div class="bs-cal-container">
			<div class="bs-cal-grid">
				<Month
					:month="aMonth"
					:min="min"
					:max="max"
					:today="today"
					:attrs="attrs"
					@setMonth="setMonth"
				/>
			</div>
		</div>
	`,
	methods: {
		setMonth (month) {
			this.aMonth = month
			this.$emit('setMonth', month)
		}
	}
}
